<template>
  <div class="firefighting-home" ref="monitorEl">
    <RightButton ref="rightButtonRef" :model="model" @switchMenu="handleSwitchMenu" />

    <SplitScreen class="firefighting-home_content">
      <div class="firefighting-home_content-left scrollbar-thin" v-if="showMonitorDetails">
        <IFramePage
          style="height: calc(80% - 5px); min-height: calc(80% - 5px)"
          v-for="(page, index) in monitorPages"
          @close="handleIFrameClose(index)"
          :has-close="true"
          :src="page.src"
          :key="page.src"
        />
      </div>
      <div class="firefighting-home_content-right">
        <router-view />
      </div>
    </SplitScreen>

    <DeviceParamsDialog
      v-if="params.visible"
      :sn="params.sn"
      :deviceType="params.deviceType"
      :visible.sync="params.visible"
    />
  </div>
</template>

<script>
import RightButton from './components/RightButton/index.vue';
import DeviceParamsDialog from '@/components/deviceParamDialog/index.vue';
import SplitScreen from '@/components/splitScreen/index.vue';
import IFramePage from '@/components/iframePage/index.vue';

import { mapActions, mapState } from 'vuex';

import ctt from '@/utils/const';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    IFramePage,
    SplitScreen,
    RightButton,
    DeviceParamsDialog
  },
  sockets: {
    '/socket/detail'(data) {
      if (data.sn !== this.weatherDeviceSn) return;

      const { mods } = data;

      const { weatherMod } = mods;

      Object.assign(this.weatherDeviceDetails, {
        windSpeed: weatherMod.windSpeed,
        windDirection: weatherMod.windDirection,
        windScale: weatherMod.windScale,
        windSpeedValue: weatherMod.windSpeedValue,
        windDirectionValue: weatherMod.windDirectionValue,
        temp: weatherMod.temp,
        humidity: weatherMod.humidity,
        atm: weatherMod.atm,
        radiation: weatherMod.radiation
      });
    }
  },
  data() {
    return {
      monitorPages: [],
      weatherDeviceSn: '',
      weatherDeviceDetails: {
        windSpeed: '',
        windDirection: '',
        windScale: '',
        windSpeedValue: '',
        windDirectionValue: '',
        temp: '',
        humidity: '',
        atm: '',
        radiation: ''
      },
      model: {
        officeId: sessionStorage.getItem('currentfirefightingOfficeId'),
        officeType: sessionStorage.getItem('currentfirefightingOfficeType')
      },
      params: {
        sn: '',
        deviceType: '',
        visible: false
      }
    };
  },
  provide() {
    return {
      openParamsDialog: params => this.openParamsDialog(params),
      currentOfficeInfo: this.model,
      splitScreenMode: () => this.showMonitorDetails, // 直接提供data中的值
      weatherDeviceDetails: this.weatherDeviceDetails,
      addToMonitorList: params => this.addToMonitorList(params)
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap']),
    showMonitorDetails() {
      return this.monitorPages.length > 0;
    },
    filterNoPosDevices() {
      return this.devicesSourseMap.filter(e => e.latitude !== 0 || e.longitude !== 0);
    }
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    handleIFrameClose(index) {
      this.monitorPages.splice(index, 1);
    },
    handleSwitchMenu(key) {
      console.log(key);
    },
    openParamsDialog(params) {
      this.params.deviceType = params.deviceType;
      this.params.sn = params.sn;
      this.params.visible = true;
    },
    addToMonitorList({ sn, deviceType }) {
      const index = this.monitorPages.findIndex(e => e.sn === sn);

      if (index !== -1) {
        this.$message.warning('已添加到多屏监控');
        return;
      }

      const res = this.$router.resolve({ name: 'Realdata', params: { sn, deviceType } });

      const name = `ht-${sn}`;

      const pathPrefix = res.href.startsWith('#') ? '#' : '';

      const path = pathPrefix + res.resolved.fullPath;

      this.monitorPages.push({ sn, deviceType, src: `${path}?windowName=${name}` });
    },
    subWeatherDeviceDetails() {
      const weatherDevices = this.devicesSourseMap.filter(e => e.deviceType === ctt.PTQXZ);

      if (isEmpty(weatherDevices)) return;

      const sn = weatherDevices[0].sn;

      this.weatherDeviceSn = sn;

      this.subDeviceDetail({ sn });
    }
  },
  watch: {
    model: {
      handler(val) {
        sessionStorage.setItem('currentfirefightingOfficeId', val.officeId);
        sessionStorage.setItem('currentfirefightingOfficeType', val.officeType);
      },
      deep: true
    }
  },
  mounted() {
    this.subWeatherDeviceDetails();
  },
  beforeDestroy() {
    if (this.weatherDeviceSn) this.unsubDeviceDetail({ sn: this.weatherDeviceSn });
  }
};
</script>

<style lang="scss">
.firefighting-home {
  position: relative;
  height: 100%;

  --gap: 15px;

  --bottom-width: 100%;
  --bottom-height: 45%;
  --top-height: calc(55% - var(--gap));
  --header-height: 90px;

  --mcard-header-title-color: #aed6ff;

  --mcard-header-fs: 26px;

  --aside-bar-width: 90px;
  --aside-bar-font-size: 14px;
  --aside-bar-padding: 40px 6px;

  --monitor-footer-height: 110px;
  --monitor-footer-chart-size: 120px;

  @media screen and (max-width: 1200px) {
    --aside-bar-width: 68px;
    --aside-bar-font-size: 13px;
    --aside-bar-padding: 40px 6px;

    --mcard-header-fs: 18px;
    --mcard-header-height: 32px;

    --monitor-footer-height: 110px;
    --monitor-footer-chart-size: 92px;
  }

  &_content {
    width: 100%;
    height: 100%;

    display: flex;

    position: absolute;
    z-index: 6;

    &-left {
      width: 100%;
      height: 100%;

      overflow: hidden auto;

      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &-right {
      width: 100%;
      // width: calc(100% - var(--left-width) - var(--gap));
      height: 100%;
    }
  }

  .el-tree-select {
    .el-select {
      width: 276px;
    }
  }

  .nova-contextmenu {
    padding: 0;

    & > ul {
      li {
        list-style: none;
        padding: 7px 15px;
        cursor: pointer;
        transition: background 0.3s ease;
        height: 26px;
        line-height: 26px;
      }
    }
  }

  .position-dialog-wrap {
    .el-dialog {
      background: url('/static/image/firefighting/dialog-bg.png') 0 0 / 100% 100% no-repeat;

      &__title {
        line-height: 24px;
        font-size: 23px;
        color: #fff;
        font-weight: bold;
      }

      &__header {
        text-align: center;
        padding: 13px 20px 10px;
      }

      &__body {
        padding: 10px;
      }
    }
  }
}
</style>
